import { Requester } from './Requester';
import { IOrgRecord, TableQueryParams } from '../types';

export const GetOrganizations = async (
    options: TableQueryParams
): Promise<{ organizations: IOrgRecord[]; totalRecords: number } | null> => {
    try {
        const response = await Requester<{
            organizations: IOrgRecord[];
            totalRecords: number;
        }>({
            // port: '8080',
            path: 'organizations/paged',
            method: 'PUT',
            payload: options
        });

        if ('organizations' in response && Array.isArray(response.organizations)) return response;
        return null;
    } catch (e) {
        console.error('Get orgs request failed');
        return Promise.reject(e);
    }
};
